import { SortDirection } from '@angular/material/sort';

import { BaseListFilter } from '../../../models/base-list-filter.model';
import { UserAccountingStatusEnum } from './user-accounting-status.enum';
import { UserStatusEnum } from './user-status.enum';

export class UsersFilter extends BaseListFilter {
  search?: string;
  searchByFullName?: string;
  searchByEmail?: string;
  createdAtFrom?: Date;
  createdAtTo?: Date;
  originationDateFrom?: Date;
  originationDateTo?: Date;
  status?: UserStatusEnum | UserStatusEnum[] = UserStatusEnum.Active;
  accountingStatus?: UserAccountingStatusEnum | UserAccountingStatusEnum[] =
    UserAccountingStatusEnum.None;
  brokerId?: number;
  discountId?: number;
  phoneNumber?: string;
  id?: string | number;
  state?: string;
  sortBy: string = 'id';
  sortDirection: SortDirection = 'desc';
  calculateBalances?: boolean;
  //
  brokerName?: string;
  inExternalCollection?: boolean;
  permanentSuspension?: boolean;
  prequalify?: boolean;
  // custom filters
  selectedFilterIndex? = 0;
}
